import React from "react";
import { formatMallaCourseStats } from "../../utils/mallaCourseDisplay";

function MallaCourseCard({ materia, trayecto, onSelect, compact = false }) {
  const handleActivate = () => {
    if (onSelect) onSelect(materia, trayecto);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleActivate();
    }
  };

  return (
    <article
      className={`course-detail__materia-item${
        onSelect ? " course-detail__materia-item--interactive" : ""
      }`}
      title={materia.Titulo}
      tabIndex={onSelect ? 0 : undefined}
      role={onSelect ? "button" : undefined}
      onClick={onSelect ? handleActivate : undefined}
      onKeyDown={onSelect ? handleKeyDown : undefined}
    >
      {materia.Clave && (
        <span className="course-detail__materia-item__clave">{materia.Clave}</span>
      )}
      <h6 className={compact ? "course-detail__materia-item__title--clamp" : undefined}>
        {materia.Titulo}
      </h6>
      <p>{formatMallaCourseStats(materia)}</p>
      {onSelect && (
        <span className="course-detail__materia-item__tap-hint" aria-hidden="true">
          Ver detalle
          <span className="course-detail__materia-item__tap-icon">›</span>
        </span>
      )}
    </article>
  );
}

export default MallaCourseCard;
